import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { Icon } from "@smartsheet/ursa-icons";
export var CheckmarkStyled = styled(Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n"])));
//# sourceMappingURL=CheckmarkStyled.js.map